import type { Eip1193Provider } from "ethers";
import { BaseWalletAdapter } from "./BaseWalletAdapter";

export class InjectedAdapter extends BaseWalletAdapter {
  readonly name = "injected";

  get installed(): boolean {
    return Boolean(this.resolveProvider());
  }

  protected resolveProvider(): Eip1193Provider | undefined {
    if (typeof window === "undefined") return undefined;
    return (window as any).ethereum;
  }
}
